import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './interceptors/auth.interceptor';
import { provideServiceWorker } from '@angular/service-worker';
import { routes } from './app.routes';
import { ViewportHeightService } from './services/viewport-height.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    // Start measuring the real viewport height before the first page renders,
    // so `--app-vh` is already a trustworthy pixel value by the time the shell
    // lays out. See ViewportHeightService for why iOS needs this.
    provideAppInitializer(() => { inject(ViewportHeightService).init(); }),
    // Register Angular's native service worker (ngsw-worker.js).
    // It handles push notifications, caching, and updates out of the box.
    // registerImmediately ensures the SW is active before SwPush.requestSubscription().
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerImmediately'
    })
  ]
};
